<template>
  <div class="flex items-center gap-3">
    <div class="h-8 w-8 rounded-full overflow-hidden ring-1 ring-gray-200">
      <img
        :src="user_details.avatar_image || '/profile_photo.jpg'"
        class="h-8 w-8 aspect-square object-cover"
        :class="{ 'privacy-blur': isBlurred }"
        alt="Profile"
      />
    </div>
    <div class="flex-1">
      <div class="flex items-center gap-2">
        <div class="text-sm font-medium text-gray-900 truncate" :class="{ 'privacy-blur': isBlurred }">
          {{ user_details.first_name }} {{ user_details.last_name }}
        </div>
        <div class="flex gap-2">
          <a
            v-if="!isBlurred && user_details.linkedin_profile_url"
            :href="user_details.linkedin_profile_url"
            target="_blank"
            class="text-gray-500 hover:text-gray-700"
          >
            <img src="/linkedin_logo.svg" class="w-4 h-4" alt="LinkedIn" />
          </a>
          <a
            v-if="!isBlurred && user_details.telegram_username"
            :href="'https://t.me/' + user_details.telegram_username.replace('@', '')"
            target="_blank"
            class="text-gray-500 hover:text-gray-700"
          >
            <img src="/telegram_logo.svg" class="w-4 h-4" alt="Telegram" />
          </a>
        </div>
      </div>
      <div class="text-gray-500 text-xs font-normal truncate" :class="{ 'privacy-blur': isBlurred }">
        {{ user_details.email }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DisplayUserDetails } from '@/types/user'
import { usePrivacy } from '@/composables/usePrivacy'

const { isBlurred } = usePrivacy()

const props = defineProps<{
  user_details: DisplayUserDetails
}>()
</script>